export function decodeHtmlEntities(text: string): string {
  if (!text) return '';
  let s = text;
  let prev = '';
  let guard = 0;
  while (s !== prev && guard++ < 12) {
    prev = s;
    s = s
      .replace(/&#(\d+);/g, (_, d) => String.fromCharCode(parseInt(d, 10)))
      .replace(/&#x([0-9a-f]+);/gi, (_, h) => String.fromCharCode(parseInt(h, 16)))
      .replace(/&nbsp;/g, '\u00a0')
      .replace(/&quot;/g, '"')
      .replace(/&apos;/g, "'")
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&amp;/g, '&');
  }
  return s;
}

export function fixDoubleEncodedHtmlEntities(html: string): string {
  if (!html) return '';
  let s = html;
  let prev = '';
  let guard = 0;
  while (s !== prev && guard++ < 10) {
    prev = s;
    s = s
      .replace(/&amp;amp;/g, '&amp;')
      .replace(/&amp;lt;/g, '&lt;')
      .replace(/&amp;gt;/g, '&gt;')
      .replace(/&amp;quot;/g, '&quot;')
      .replace(/&amp;#39;/g, '&#39;')
      .replace(/&amp;nbsp;/g, '&nbsp;');
  }
  return s;
}

export function normalizePropertyDescriptionText(raw: string): string {
  if (!raw) return '';
  let s = decodeHtmlEntities(raw.trim());
  let prev = '';
  while (s !== prev) {
    prev = s;
    s = s
      .replace(/([a-z])\.([A-Z])/g, '$1. $2')
      .replace(/([a-z])!([A-Z])/g, '$1! $2')
      .replace(/([a-z])\?([A-Z])/g, '$1? $2')
      .replace(/([а-яё])\.([А-ЯЁ])/g, '$1. $2')
      .replace(/([а-яё])!([А-ЯЁ])/g, '$1! $2')
      .replace(/([а-яё])\?([А-ЯЁ])/g, '$1? $2');
  }
  s = s.replace(
    /\.\s+((?:The|Featuring|Situated|Located|With|Apartments|Residents|State-of-the-art|This|These|Offering|Designed|Built|Nestled|Ellington)\b)/gi,
    '.\n\n$1',
  );
  return s.replace(/\n{3,}/g, '\n\n').trim();
}
